const normalize = (type?: string) => (type ?? '').trim().toUpperCase();

export const isExtraSpaceCellar = (type?: string) => normalize(type) === 'CANTINA';

const GARAGE_TYPES = new Set(['BOX', 'BOX AUTO MOTO', 'POSTO AUTO']);
export const isExtraSpaceGarage = (type?: string) => GARAGE_TYPES.has(normalize(type));
